// import Rating from "react-rating";
import { FaRegStar, FaStar, FaStarHalf } from "react-icons/fa";
import { forwardRef, useEffect, useState } from "react";
import { LuCalendarDays } from "react-icons/lu";
import ReactDatePicker from "react-datepicker";
import MultiSelect from "react-select";
import { components } from "react-select";
import { Form } from "react-bootstrap";
import { CiSearch } from "react-icons/ci";
import PhoneInput from "react-phone-input-2";

// export const RatingStar = ({ user, rating, ...rest }) => {
//   const [ratingValue, setRatingValue] = useState(rating);

//   useEffect(() => {
//     setRatingValue(ratingValue);
//   }, [ratingValue]);
//   return (
//     <>
//       <div className="rating">
//         <span className="_rating">{ratingValue}</span>
//         <Rating
//           className="rating_star"
//           emptySymbol={<FaRegStar />}
//           allowFraction={<FaStarHalf />}
//           fullSymbol={<FaStar />}
//           {...rest}
//         />
//         <span className="user">{user}</span>
//       </div>
//     </>
//   );
// };

export const Button = ({
  type = "button",
  className,
  children,
  loading,
  ...rest
}) => {
  return (
    <>
      <button type={type} className={`button ${className}`} {...rest}>
        {loading ? (
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="24px"
            height="30px"
            viewBox="0 0 24 30"
            // style="enable-background:new 0 0 50 50;"
          >
            <rect x="0" y="13" width="4" height="5" fill="#fff">
              <animate
                attributeName="height"
                attributeType="XML"
                values="5;21;5"
                begin="0s"
                dur="0.6s"
                repeatCount="indefinite"
              />
              <animate
                attributeName="y"
                attributeType="XML"
                values="13; 5; 13"
                begin="0s"
                dur="0.6s"
                repeatCount="indefinite"
              />
            </rect>
            <rect x="10" y="13" width="4" height="5" fill="#fff">
              <animate
                attributeName="height"
                attributeType="XML"
                values="5;21;5"
                begin="0.15s"
                dur="0.6s"
                repeatCount="indefinite"
              />
              <animate
                attributeName="y"
                attributeType="XML"
                values="13; 5; 13"
                begin="0.15s"
                dur="0.6s"
                repeatCount="indefinite"
              />
            </rect>
            <rect x="20" y="13" width="4" height="5" fill="#fff">
              <animate
                attributeName="height"
                attributeType="XML"
                values="5;21;5"
                begin="0.3s"
                dur="0.6s"
                repeatCount="indefinite"
              />
              <animate
                attributeName="y"
                attributeType="XML"
                values="13; 5; 13"
                begin="0.3s"
                dur="0.6s"
                repeatCount="indefinite"
              />
            </rect>
          </svg>
        ) : (
          children
        )}
      </button>
    </>
  );
};

export const LoadingButton = ({
  isDisabled = false,
  children,
  loading,
  className = "",
  ...rest
}) => {
  return (
    <button
      className={`button has_loader ${className}`}
      {...rest}
      disabled={isDisabled}
    >
      {loading ? (
        <>
          {/* <span
            className="spinner-grow spinner-grow-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Loading... */}
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="24px"
            height="30px"
            viewBox="0 0 24 30"
            // style="enable-background:new 0 0 50 50;"
          >
            <rect x="0" y="13" width="4" height="5" fill="#fff">
              <animate
                attributeName="height"
                attributeType="XML"
                values="5;21;5"
                begin="0s"
                dur="0.6s"
                repeatCount="indefinite"
              />
              <animate
                attributeName="y"
                attributeType="XML"
                values="13; 5; 13"
                begin="0s"
                dur="0.6s"
                repeatCount="indefinite"
              />
            </rect>
            <rect x="10" y="13" width="4" height="5" fill="#fff">
              <animate
                attributeName="height"
                attributeType="XML"
                values="5;21;5"
                begin="0.15s"
                dur="0.6s"
                repeatCount="indefinite"
              />
              <animate
                attributeName="y"
                attributeType="XML"
                values="13; 5; 13"
                begin="0.15s"
                dur="0.6s"
                repeatCount="indefinite"
              />
            </rect>
            <rect x="20" y="13" width="4" height="5" fill="#fff">
              <animate
                attributeName="height"
                attributeType="XML"
                values="5;21;5"
                begin="0.3s"
                dur="0.6s"
                repeatCount="indefinite"
              />
              <animate
                attributeName="y"
                attributeType="XML"
                values="13; 5; 13"
                begin="0.3s"
                dur="0.6s"
                repeatCount="indefinite"
              />
            </rect>
          </svg>
        </>
      ) : (
        children
      )}
    </button>
  );
};

export const Input = forwardRef(
  (
    {
      value = "",
      onChange,
      className = "",
      label,
      error,
      required,
      extraError = false,
      infoErr = false,
      optional = false,
      subText,
      maxlength = "100",
      ...rest
    },
    ref
  ) => {
    const classGenerator = () => {
      if (infoErr && extraError) {
        return "is-invalid";
      }
      if (infoErr) {
        return "info";
      }
      return ((!value && error) || extraError) && "is-invalid";
    };
    return (
      <>
        {label && (
          <label className="label">
            {label}
            {required && <span className="required mx-1"> *</span>}
            {optional && <em className="optional">{"(optional)"}</em>}
            {subText && <span className="subText">{subText}</span>}
          </label>
        )}
        <input
          value={value}
          maxLength={maxlength}
          onChange={onChange}
          className={`form-control input ${className} ${classGenerator()}`}
          ref={ref}
          {...rest}
        />
        {error && (
          <span className={`${infoErr ? "info-feedback" : "invalid-feedback"}`}>
            {error}
          </span>
        )}
      </>
    );
  }
);

export const Select = forwardRef(
  (
    {
      label,
      onChange,
      value,
      error,
      className = "",
      children,
      required,
      optional,
      ...rest
    },
    ref
  ) => {
    return (
      <>
        {label && (
          <label className="label">
            {label}
            {required && <span className="required mx-1"> *</span>}
            {optional && <em className="optional">{"(optional)"}</em>}
          </label>
        )}
        <select
          onChange={onChange}
          value={value}
          className={`form-control input ${className} ${
            !value && error && "is-invalid"
          }`}
          ref={ref}
          {...rest}
        >
          {children}
        </select>
        {error && <span className="invalid-feedback">{error}</span>}
      </>
    );
  }
);

export const TextArea = forwardRef(
  ({ value, onChange, label, className = "", error, ...rest }, ref) => {
    return (
      <>
        {label && <label className="my-1 label">{label}</label>}
        <textarea
          value={value}
          onChange={onChange}
          className={`form-control input ${className} ${
            !value && error && "is-invalid"
          }`}
          ref={ref}
          {...rest}
        />
        {error && <span className="invalid-feedback">{error}</span>}
      </>
    );
  }
);

export const DatePicker = forwardRef(
  (
    {
      value,
      onChange,
      className = "",
      label,
      error,
      required,
      extraError = false,
      infoErr = false,
      optional = false,
      placeholder,
      ...rest
    },
    ref
  ) => {
    const classGenerator = () => {
      if (infoErr && extraError) {
        return "is-invalid";
      }
      if (infoErr) {
        return "info";
      }
      return ((!value && error) || extraError) && "is-invalid";
    };

    return (
      <>
        {label && (
          <label className="label">
            {label}
            {required && <span className="required mx-1"> *</span>}
            {optional && <em className="optional">{"(optional)"}</em>}
          </label>
        )}
        <ReactDatePicker
          ref={ref}
          className={`form-control input date_picker ${className} ${classGenerator()}`}
          showIcon
          icon={<LuCalendarDays />}
          selected={value}
          onChange={onChange}
          dateFormat={"dd-MMM-yyyy"}
          showMonthDropdown
          useShortMonthInDropdown
          showYearDropdown
          scrollableYearDropdown
          yearDropdownItemNumber={300}
          onChangeRaw={(e) => e.preventDefault()}
          {...rest}
          placeholderText={placeholder}
        />
        {!value && error && (
          <span
            className={`${
              infoErr ? "info-feedback" : "invalid-feedback"
            } d-block`}
          >
            {error}
          </span>
        )}
      </>
    );
  }
);

export const YearPicker = forwardRef(
  (
    {
      value,
      onChange,
      className = "",
      label,
      error,
      required,
      extraError = false,
      infoErr = false,
      optional = false,
      ...rest
    },
    ref
  ) => {
    const classGenerator = () => {
      if (infoErr && extraError) {
        return "is-invalid";
      }
      if (infoErr) {
        return "info";
      }
      return ((!value && error) || extraError) && "is-invalid";
    };

    return (
      <>
        {label && (
          <label className="label">
            {label}
            {required && <span className="required mx-1"> *</span>}
            {optional && <em className="optional">{"(optional)"}</em>}
          </label>
        )}
        <ReactDatePicker
          ref={ref}
          className={`form-control input ${className} ${classGenerator()}`}
          showIcon
          icon={<LuCalendarDays />}
          selected={value}
          onChange={onChange}
          dateFormat="yyyy"
          // useShortMonthInDropdown
          // showYearDropdown
          // scrollableYearDropdown
          showYearPicker
          onChangeRaw={(e) => e.preventDefault()}
          {...rest}
          yearDropdownItemNumber={300}
        />
        {!value && error && (
          <span
            className={`${
              infoErr ? "info-feedback" : "invalid-feedback"
            } d-block`}
          >
            {error}
          </span>
        )}
      </>
    );
  }
);

export const CommonSelect = ({
  label,
  onChange,
  value,
  error,
  className = "",
  options = [],
  isMulti = false,
  isSearchable = false,
  noOptionsMessage = () => "No options found",
  required = false,
  loading = false,
  isDisabled = false,
  placeholder = "Select",

  ...rest
}) => {
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      background: state.isSelected
        ? "linear-gradient(180deg, #01b4a7 0%, #00aace 100%)"
        : "#fff", // Change background color of selected option
      color: state.isSelected
        ? "linear-gradient(180deg, #01b4a7 0%, #00aace 100%)"
        : "black", // Change text color of selected option
      "&:hover": {
        background: "linear-gradient(180deg, #01b4a7 0%, #00aace 100%)", // Change background color of option on hover
        color: "#fff", // Change text color of option on hover
      },
    }),
    loadingIndicator: (base, state) => ({
      ...base,
      color: "#FF8989", // Set the color to red
    }),
  };

  const LoadingIndicator = (props) => {
    return (
      <components.LoadingIndicator {...props}>
        {/* <ClipLoader size={20} color="#999" loading={true} />
         */}
        <p>Loading...</p>
      </components.LoadingIndicator>
    );
  };

  const handleChange = (selectedOptions) => {
    // console.log(selectedOptions, "SelectedOptions");
    onChange(selectedOptions);
  };
  return (
    <div>
      {label && (
        <label className="label">
          {label}

          {required && <span className="text-black"> *</span>}
        </label>
      )}

      <MultiSelect
        onChange={handleChange}
        value={value}
        className={`multi-select ${className} ${
          !value && error && "is-invalid"
        }`}
        options={options}
        isMulti={isMulti}
        placeholder={placeholder}
        isSearchable={isSearchable}
        noOptionsMessage={noOptionsMessage}
        isLoading={loading}
        styles={customStyles}
        isDisabled={isDisabled}
        classNamePrefix="react_select"
        // placeholderText={placeholder}
        components={{ LoadingIndicator }}
        {...rest}
      />
      {/* {leftIcon} */}
      {error && <div className="invalid-feedback d-flex">{error}</div>}
    </div>
  );
};

// Switch Button //

export const SwitchButton = ({
  className = "",
  status = false,
  disabled,
  ...rest
}) => {
  return (
    <>
      <label className={`switch ${className} ${disabled ? "disabled" : ""}`}>
        <input
          type="checkbox"
          defaultChecked={status}
          disabled={disabled}
          {...rest}
        />
        <span className="slider round"></span>
      </label>
    </>
  );
};

// Search Component
export const Search = () => {
  return (
    <>
      <Form>
        <CiSearch />
        <Form.Control
          type="search"
          placeholder="Search..."
          className="me-2 input"
          aria-label="Search"
        />
      </Form>
    </>
  );
};

// Handle Phone Input Change
export const PhoneInputComponent = ({
  defaultCountry = "in",
  value = "",
  onChange,
  error = "",
  placeholder = "Enter Mobile Number",
  countryCodeEditable = false,
  enableSearch = true,
}) => {
  const [phoneDetails, setPhoneDetails] = useState({
    number: "",
    completeMobile: "",
    dialCode: "",
  });

  const handlePhoneChange = (phone) => {
    if (!phone) {
      setPhoneDetails({
        number: "",
        completeMobile: "",
        dialCode: "",
      });
      onChange?.("");
      return;
    }

    try {
      const country = PhoneInput.getCountryCallingCode(
        PhoneInput.parsePhoneNumber(phone)?.country || defaultCountry
      );
      const phoneWithoutCountryCode = phone.replace(`+${country}`, "");

      const updatedDetails = {
        number: phoneWithoutCountryCode,
        completeMobile: phone,
        dialCode: `+${country}`,
      };

      setPhoneDetails(updatedDetails);
      onChange?.(updatedDetails);
    } catch (err) {
      console.error("Invalid phone number format:", err);
      setPhoneDetails({
        number: phone,
        completeMobile: phone,
        dialCode: "",
      });
      onChange?.({ number: phone, completeMobile: phone, dialCode: "" });
    }
  };

  return (
    <div className="phone_input">
      <PhoneInput
        defaultCountry={defaultCountry.toLowerCase()} // Ensure country code is lowercase
        value={value || phoneDetails.completeMobile}
        onChange={handlePhoneChange}
        enableSearch={enableSearch}
        placeholder={placeholder}
        countryCodeEditable={countryCodeEditable}
      />
      {/* Display error if provided */}
      {error && <span className="invalid-feedback d-block">{error}</span>}
    </div>
  );
};
